(() => {
  const setup = async () => {
    await customElements.whenDefined('predictive-search');
    document.querySelectorAll('#identity > .large-search predictive-search').forEach((search) => {
      if (search.dataset.searchUxReady) return;
      search.dataset.searchUxReady = 'true';
      const input = search.querySelector('input[name="q"]');
      const results = search.querySelector('#predictive-search');
      if (!input || !results) return;
      const overlay = document.createElement('div');
      overlay.className = 'mobile-search-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.hidden = true;
      document.body.append(overlay);
      let dismissed = false;
      let request;
      let revision = 0;
      const originalOpen = search.open.bind(search);
      const updateHeight = () => {
        const viewport = window.visualViewport;
        const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
        results.style.setProperty('--search-results-height', `${Math.max(80, bottom - input.getBoundingClientRect().bottom - 16)}px`);
      };
      search.close = () => {
        dismissed = true;
        revision++;
        request?.abort();
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        overlay.hidden = true;
        document.body.classList.remove('mobile-search-is-open');
      };
      search.open = () => {
        if (dismissed || !input.value.trim() || !search.contains(document.activeElement)) return;
        results.hidden = false;
        originalOpen();
        input.setAttribute('aria-expanded', 'true');
        overlay.hidden = false;
        document.body.classList.add('mobile-search-is-open');
        updateHeight();
      };
      search.getSearchResults = async (term) => {
        if (dismissed || !term || !search.contains(document.activeElement)) return;
        request?.abort();
        request = new AbortController();
        const current = ++revision;
        try {
          const response = await fetch(`${search.routesPredictiveSearchURL}?q=${encodeURIComponent(term)}&section_id=predictive-search`, { signal: request.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const html = await response.text();
          if (current !== revision || dismissed || input.value.trim() !== term) return;
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-predictive-search');
          if (!content) { search.close(); return; }
          results.innerHTML = content.innerHTML;
          search.open();
        } catch (error) {
          if (error.name !== 'AbortError' && current === revision) search.close();
        }
      };
      input.addEventListener('input', () => {
        search.close();
        dismissed = false;
      });
      input.addEventListener('focus', () => {
        dismissed = false;
        if (input.value.trim()) search.getSearchResults(input.value.trim());
      });
      search.addEventListener('focusout', () => {
        setTimeout(() => { if (!search.contains(document.activeElement)) search.close(); }, 0);
      });
      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          input.focus({ preventScroll: true });
          search.close();
        }
      });
      document.addEventListener('pointerdown', (event) => {
        if (!search.contains(event.target)) {
          search.close();
          if (event.target === overlay) input.blur();
        }
      });
      window.visualViewport?.addEventListener('resize', updateHeight);
      window.addEventListener('resize', updateHeight);
      search.close();
    });
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
